import { PATHS } from '@tom-ui/utils'
import { useNavigate } from 'react-router'

export const useContainerTurnoverPositionUpdate = () => {
  const navigate = useNavigate()

  return (containerTurnoverId: string) => {
    if (!containerTurnoverId) return

    navigate(`${PATHS.operators.operatorContainerTurnoversList.url}/${containerTurnoverId}`)
  }
}
